export default function TotalClientsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M4 16C4 16 3 16 3 15C3 14 4 11 8 11C12 11 13 14 13 15C13 16 12 16 12 16H4Z"
        fill="#FFC700"
      />
      <path
        d="M8 10.05C9.38071 10.05 10.5 8.93072 10.5 7.55001C10.5 6.1693 9.38071 5.05001 8 5.05001C6.61929 5.05001 5.5 6.1693 5.5 7.55001C5.5 8.93072 6.61929 10.05 8 10.05Z"
        fill="#FFC700"
      />
      <path
        d="M2 1C0.895431 1 0 1.89543 0 3V12.5C0 13.3284 0.671573 14 1.5 14H2.15288C2.32816 13.3735 2.66508 12.6544 3.21878 12H1V3C1 2.44772 1.44772 2 2 2H14C14.5523 2 15 2.44772 15 3V12H12.7812C13.3349 12.6544 13.6718 13.3735 13.8471 14H14.5C15.3284 14 16 13.3284 16 12.5V3C16 1.89543 15.1046 1 14 1H2Z"
        fill="#FFC700"
      />
    </svg>
  );
}
